import Vue from 'vue'
export default (ctx, inject) => {
  let first = true
  const { store } = ctx
  if (store.state.auth.locked)
    store.dispatch('auth/logout', {
      silent: true,
      forced: true,
      reason: 'Reinforce lock',
    })
  const state = Vue.observable({
    online: true,
    hasBeenOnline: true,
    hasBeenOffline: false,
  })
  if ('onLine' in navigator) {
    state.online = navigator.onLine
    // Always commit the real connectivity state at startup.
    // VuexPersistence may have restored a stale `isOffline` value from a previous session,
    // so we override it here before any event-driven handlers take over.
    store.commit('offline/setOffline', !navigator.onLine)
    document.body.classList.toggle('offline', !navigator.onLine)
    const onlineHandler = () => {
      if (first) {
        first = false
        return
      }
      state.online = true
      state.hasBeenOnline = true
      store.commit('offline/setOffline', false)
      document.body.classList.toggle('offline', false)
      ctx.$telemetry.pushEvent({
        name: 'offlineState',
        action: 'change',
        result: false,
      })
    }
    const offlineHandler = () => {
      if (first) {
        first = false
        return
      }
      state.online = false
      state.hasBeenOffline = true
      store.commit('offline/setOffline', true)
      document.body.classList.toggle('offline', true)
      ctx.$telemetry.pushEvent({
        name: 'offlineState',
        action: 'change',
        result: true,
      })
    }
    window.addEventListener('online', onlineHandler)
    window.addEventListener('offline', offlineHandler)
    if (!navigator.onLine) {
      state.hasBeenOnline = false
      offlineHandler()
      return
    }
    onlineHandler()
  }
  ctx.$pwa = state
  inject('pwa', state)
}
